import classNames from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { throttle } from 'throttle-debounce';

import { HEADER_HEIGHTS } from '../../../constants/breakpoints';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
import { useViewportScroll } from '../../../hooks/useViewportScroll';
import { LayoutTheme } from '../../Layout/types';

interface Props {
  theme?: LayoutTheme;
  className?: string;
  ctaRef: React.RefObject<HTMLAnchorElement>;
  children?: React.ReactNode;
}

const StickyHeader: React.FC<Props> = ({
  children,
  className,
  ctaRef,
  theme = 'light',
}) => {
  const { scrollY } = useViewportScroll();
  const [stickyVisible, setStickyVisible] = useState(false);
  const breakpoint = useBreakpoint();

  const headerHeight =
    breakpoint.name === 'sm' ? HEADER_HEIGHTS.MOBILE : HEADER_HEIGHTS.DESKTOP;

  const handleScroll = useMemo(
    () =>
      throttle(200, false, () => {
        setStickyVisible(
          ctaRef.current !== null &&
            headerHeight > ctaRef.current.getBoundingClientRect().bottom,
        );
      }),
    [headerHeight],
  );

  useEffect(() => {
    handleScroll();
  }, [scrollY, handleScroll]);

  return (
    <div
      className={classNames(
        'fixed left-0 top-14 z-80 w-full border-b border-divider/20 transition-transform duration-300 md:top-18',
        theme === 'dark' ? 'bg-neutral-6' : 'bg-white',
        {
          '-translate-y-24 md:-translate-y-20': !stickyVisible,
          '-translate-y-0 md:-translate-y-0': stickyVisible,
        },
        className,
      )}
    >
      <div className="wrapper-website m-auto flex flex-row items-center justify-between py-3">
        {children}
      </div>
    </div>
  );
};

export default StickyHeader;
